import { useChatStatusWithCircles } from "./useChatStatus";

/**
 * Hook that centralizes chat visibility logic across the application.
 * 
 * This hook determines whether chat features should be visible based on:
 * 1. The backend chat system variable (on/off/exclude/include)
 * 2. User's circle membership
 * 3. Optional local override (isChatDisabled prop)
 * 
 * @param isChatDisabled - Optional local override to disable chat (e.g., from props)
 * @returns Object containing chat visibility state and loading status
 */
export function useChatVisibility(isChatDisabled?: boolean) {
  const { isChatEnabled, isLoading } = useChatStatusWithCircles();

  // Determine if chat should be visible
  // If there's a local override (isChatDisabled), respect it
  // Otherwise, use the system-wide chat status
  const shouldShowChat = isChatDisabled ? false : isChatEnabled;

  return {
    shouldShowChat,
    isLoading,
    isChatEnabled,
    isChatDisabled: isChatDisabled || false,
  };
}
